import React from 'react';
import Avatar from '@mui/material/Avatar/Avatar';
import useUserInfoStyles from './useUserInfoStyles';
import useGlobalStyles from '../../../useGlobalStyles';

/**
 * Interface representing the props for the UserInfo component.
 * @param profilePictureUrl - The URL of the user's profile picture.
 * @param username - The username of the user.
 * @param profilePicSize - The size of the profile picture.
 */
interface UserInfoProps {
  profilePicture: string;
  username: string;
  profilePicSize: number;
}

/**
 * UserInfo component that renders the user's profile picture and username.
 * It displays the profile picture on the left and the username on the right.
 *
 * @param profilePicture - The URL of the user's profile picture.
 * @param username - The username of the user.
 */
const UserInfo: React.FC<UserInfoProps> = ({ profilePicture, username, profilePicSize }) => {
  const { classes } = useUserInfoStyles();
  const { classes: globalClasses } = useGlobalStyles();

  return (
    <div className={classes.userInfo}>
      <Avatar
        alt='Profile Picture'
        src={`${process.env.PUBLIC_URL}/assets/profiles/${profilePicture}`}
        className={classes.avatar}
        sx={{ width: profilePicSize, height: profilePicSize }}
      />
      <p className={globalClasses.h5}>{username}</p>
    </div>
  );
};

export default UserInfo;
